import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

export default function MarkdownRenderer({ content }) {
  return (
    <ReactMarkdown
      // GFM: tabelas, checkboxes, etc.
      remarkPlugins={[remarkGfm]}
      // Sanitiza HTML (rehype-raw desabilitado por padrão)
      rehypePlugins={[rehypeSanitize]}
      // Customiza a renderização de <a> para abrir em nova aba
      components={{
        a: ({node, ...props}) => (
          <a {...props} style={{textDecoration: 'underline', fontStyle: 'italic'}} target="_blank" rel="noopener noreferrer" />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
}